module.exports = __webpack_public_path__ + "img/icon_aside_excel5_active.7175efff.svg";